import { render, staticRenderFns } from "./ArticleWriter.vue?vue&type=template&id=20397762&"
import script from "./ArticleWriter.vue?vue&type=script&lang=js&"
export * from "./ArticleWriter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports